import React from 'react'
import { numberToCurrency } from '@/lib/Number'

export default function TipAmount({
    payment,
    className=null,
    isVisible=false,
    includesTip,
    setIncludesTip=() => {},
}) {
    return isVisible && (
        <div className={className}>
            <input
                type='checkbox'
                name='tip_cents'
                id='tip_cents'
                value='tip_cents'
                checked={includesTip}
                className='mr-2'
                onChange={() => setIncludesTip(!includesTip)}
            />
            <label htmlFor='tip_cents' className='mb-0'>
                Include Tip Amount?&nbsp; ({ numberToCurrency(payment.tip_cents / 100.0) })
            </label>
        </div>
    )
}
